import { TableColumnsType } from 'antd';
import dayjs from '/react4xp/mixins/dayjsConfig';
import { localize } from '/react4xp/mixins/helpers';

export const columns = (translations: Record<string, string>): TableColumnsType => [
    {
        title: localize('find-liquidated-full-name', translations),
        dataIndex: 'nameOrFio',
        key: 'nameOrFio',
    },
    {
        title: localize('iin-bin', translations),
        dataIndex: 'iinBin',
        key: 'iinBin',
    },
    {
        title: localize('find-liquidated-begin-date', translations),
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (a) => dayjs(a).format('DD.MM.YYYY'),
    },
];
